import React from "react";
import { Link } from "react-router-dom";
const Resume = () => {
  return (
    <div className="text-center justify-center text-blue-900 sm:mt-10 p-10 sm:px-52">
      <div className=" bg-white p-10">
        <div>
          <h2 className="sm:text-4xl text-2xl font-semibold mb-2">Ansa Ali</h2>
          <p>
            {" "}
            chinjuansa@gmail.com | 8714169396 |
            <Link
              to={"https://www.linkedin.com/in/ansa-ali-anas/"}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 font-bold ml-2"
            >
              LinkedIn
            </Link>{" "}
            |{" "}
            <Link
              to={"https://github.com/AnsaAli"}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 font-bold"
            >
              GitHub
            </Link>{" "}
          </p>
        </div>

        <div>
          <div className="mt-10 p-2">
            <h2 className="text-left font-semibold sm:text-2xl text-lg ">
              {" "}
              Profile Summary
            </h2>
            <hr className="border-1 border-gray-800 w-full" />
            <p className="text-left my-5">
              Enthusiastic MERN Stack Developer with a strong foundation in
              building web applications and a passion for solving real-world
              challenges through creative solutions. Eager to apply technical
              skills, learn from industry professionals, and grow in a
              collaborative environment.
            </p>
          </div>
          <div className="sm:mt-10 p-2">
            <h2 className="text-left font-semibold sm:text-2xl text-lg ">
              {" "}
              Technical Skills
            </h2>
            <hr className="border-1 border-gray-800 w-full" />
            <ul className="text-left my-5 list-disc px-5">
              <li>Javascript, HTML, CSS</li>
              <li>
                {" "}
                <span className="font-semibold">MERN:</span> React.js, Redux,
                Redux-Toolkit, Bootstrap, Tailwind CSS
              </li>
              <li> Node.js, Express.js, RESTful API</li>
              <li> MongoDB, SQL, Firebase</li>
              <li> Razorpay, Google OAuth2.0, Multer, AWSEc2, Nodemailer</li>
              <li>
                <span className="font-semibold">UX/UI:</span> Adobe XD,
                Photoshop, Figma, Adobe Illustrator
              </li>
              <li>
                {" "}
                <span className="font-semibold">Familiar with :</span> Responsive design, MVC, DSA,
                Postman, Git, GitHub, AWS, JWT
              </li>
            </ul>
          </div>

          <div className="sm:mt-10 p-2">
            <h2 className="text-left font-semibold sm:text-2xl text-lg ">
              {" "}
              Projects
            </h2>
            <hr className="border-1 border-gray-800 w-full" />
            <ul className="text-left my-5 list-disc px-5">
              <li>
                Goeasyshop.in- Groceries e-commerce shopping application.
                <Link to={"https://goeasyshop.in/" } target="_blank" className="font-bold">
                  {" "}
                  See Project
                </Link>{" "}
              </li>
              <li>
                {" "}
                Be-Creative An Art And Craft Web- React Application{" "}
                <Link to={"https://hobby-art-fronend-5trh8dgyz-ansaalis-projects.vercel.app/"} target="_blank" className="font-bold">
                  {" "}
                  See Project
                </Link>{" "}
              </li>
              <li>
                {" "}
                OLX Clone- React Application{" "}
                <Link to={"/projects"} target="_blank" className="font-bold">
                  {" "}
                  See Project
                </Link>
              </li>
              <li>
                {" "}
                Netflix Clone- React Application{" "}
                <Link to={"/projects"} target="_blank" className="font-bold">
                  {" "}
                  See Project
                </Link>
              </li>
              <li>
                {" "}
                UX/UI{" "}
                <Link to={"/portfolio"} target="_blank" className="font-bold">
                  {" "}
                  See Project
                </Link>
              </li>
            </ul>
          </div>

          <div className="sm:mt-10 p-2">
            <h2 className="text-left font-semibold sm:text-2xl text-lg ">
              {" "}
              EXPERIENCE
            </h2>
            <hr className="border-1 border-gray-800 w-full" />
            <p className="text-left mt-5">  MERN Stack Developer</p>
            <p className="text-left ">
              {" "}
              {/* Brototype 2023- Present */}
            </p>

            <ul className="text-left my-2 list-disc px-5">
              <li>
                {" "}
                Created a full-fledged e-commerce app from scratch to deployment.
              </li>
              <li>
                {" "}
                Collaborated on key features, ensuring seamless integrations and functionality
              </li>
            </ul>

            <p className="text-left mt-5">  Mathematics teacher</p>
            <p className="text-left ">
              {" "}
              Cuemath pvt ltd
            </p>

            <ul className="text-left my-2 list-disc px-5">
              <li>
                {" "}
                I developed strong problem-solving and analytical skills by guiding students through complex mathematical
 concepts, which I now apply to debugging and coding challenges in MERN stack development.
              </li>
              <li>
                {" "}
                Myability to simplify intricate topics has also enhanced my communication skills, making me effective in
                collaborating with teams and explaining technical concepts
              </li>
            </ul>
          </div>

          <div className="sm:mt-10 p-2">
            <h2 className="text-left font-semibold sm:text-2xl text-lg ">
              {" "}
              EDUCATION
            </h2>
            <hr className="border-1 border-gray-800 w-full" />
            <ul className="text-left my-5 list-disc px-5">
            
              <li>
                {" "}
                <span className="font-semibold">
                  {" "}
                  Master of Science (Mathematics){" "}
                </span>{" "}
                : Mahatma Gandhi University, India
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
